const state = {
  pet: {},
  petHospital: {},
  vaccineInfo: {},
  antibodyInfo: {},
  geneInfo:{},
  recordDate: "",
};

const mutations = {
  SET_SELECT_PETINFO: (state, pet) => {
    state.pet = pet;
  },
  SET_PETHOSPITAL: (state, hospital) => {
    state.petHospital = hospital;
  },
  SET_VACCINEINFO: (state, vaccine) => {
    sessionStorage.setItem("vaccineInfo", JSON.stringify(vaccine));
    state.vaccineInfo = vaccine;
  },
  SET_ANTIBODYINFO: (state, antibody) => {
    sessionStorage.setItem("antibodyInfo", JSON.stringify(antibody));
    state.antibodyInfo = antibody;
  },
  SET_GENEINFO: (state, gene) => {
    sessionStorage.setItem("geneInfo", JSON.stringify(gene));
    state.geneInfo = gene;
  },
  SET_RECORDDATE: (state, time) => {
    state.recordDate = time;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
